import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import AvisoMonitoramento from 'assets/images/facilitador/icon-aviso-monitoramento.png';
import { Container } from './styles';

const MonitoringQuoted: React.FC = () => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const { search } = useLocation();
  const params = new URLSearchParams(search);

  return (
    <Container className="container p-4 mt-5">
      <div className="row justify-content-center">
        <div className="col-md-9 col-12">
          <div className="card shadow my-4">
            <div className="card-body">
              <h4 className="card-title font-weight-bold">Você foi citado em um pregão!</h4>
              <p className="text-center">
                <img className="img-fluid" src={AvisoMonitoramento} alt="monitoramento" />
              </p>
              <p className="card-text">
                Olá <strong>{profile.name}</strong>, tudo bem?
              </p>
              <p className="card-text">
                Você sabia que sua empresa foi citada no pregão eletrônico{' '}
                <strong>Número Conlicitação: {params.get('bidding_id')}</strong>?
              </p>
              <p className="card-text">
                Com a nossa ferramenta <strong>Monitorar Chat</strong>, você pode acompanhar todas
                as mensagens nos chats dos pregões eletrônicos dos principais portais e ser
                notificado sobre todas as convocações.
              </p>
              <p className="mb-0">Veja todas as vantagens:</p>
              <ul>
                <li>Acompanhe os chats do pregão eletrônico em uma única plataforma</li>
                <li>Seja avisado quando o pregão começar</li>
                <li>Receba notificações por e-mail ou pelo navegador</li>
                <li>Não corra mais o risco de perder uma convocação e sofrer penalizações</li>
                <li>Configure palavras-chave para serem monitoradas</li>
                <li>Economize seu tempo monitorando apenas as comunicações de interesse</li>
              </ul>
              <p className="text-center mb-0">
                <a
                  href="/facilitadores/monitoramento"
                  className="btn btn-text-break btn-large btn-success"
                >
                  SAIBA MAIS SOBRE O MONITORAMENTO DE CHAT
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default MonitoringQuoted;
